import { render, staticRenderFns } from "./Chunks.vue?vue&type=template&id=1f60ffde&scoped=true"
import script from "./Chunks.vue?vue&type=script&lang=js"
export * from "./Chunks.vue?vue&type=script&lang=js"
import style0 from "./Chunks.vue?vue&type=style&index=0&id=1f60ffde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f60ffde",
  null
  
)

export default component.exports